<template>
    <div class="dialogWrap">
        <!--未实名提示 -->
        <el-dialog
            title="提示"
            :visible.sync="noRealName"
            width="380px"
            top="27vh"
            class="myDialog"
            center
            :before-close="close"
            :close-on-click-modal="false"
        >
            <div class="dialog-content-center">你需要先完成账号的实名认证。</div>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="$router.push('/userCenter/AuthenticationName')">去认证</el-button>
                <el-button round class="next" @click="close">取消</el-button>
            </span>
        </el-dialog>
        <!-- 换绑失败 -->
        <el-dialog
            title="换绑失败"
            :visible.sync="bindFail"
            width="380px"
            top="27vh"
            class="myDialog"
            center
            :before-close="close"
            :close-on-click-modal="false"
        >
            <p class="tips">请使用实名信息与账号身份相符的手机号：</p>
            <p class="tips">姓名：{{userInfo.name}}</p>
            <p class="tips">身份证号：{{userInfo.idCard}}</p>
            <span slot="footer" class="dialog-footer">
                <el-button round class="next" @click="close">取消</el-button>
                <el-button round type="primary" @click="tryAgain">重试</el-button>
            </span>
        </el-dialog>
        <!-- 换绑手机号 -->
        <el-dialog
            :title="type==1?'绑定新手机号':'预绑定新手机号'"
            :visible.sync="bindPhone"
            width="480px"
            top="27vh"
            class="myDialog"
            center
            :before-close="close"
            :close-on-click-modal="false"
        >
            <el-row :gutter="20" type="flex" class="row-bg" justify="center">
                <el-col :span="20">
                    <p class="tips" v-if="type==1">新手机号的实名身份需与您的账号相同</p>
                    <p class="tips" v-if="type==2">请填写要绑定的新手机号，审核通过后将自动完成换绑</p>
                    <el-form
                        :model="changeBindPhoneForm"
                        status-icon
                        :rules="rulesPhone"
                        ref="changeBindPhoneForm"
                        label-width="0px"
                        class="demo-ruleForm"
                    >
                        <el-form-item prop="account" :error="accountError">
                            <el-input
                                type="text"
                                v-model="changeBindPhoneForm.account"
                                autocomplete="off"
                                clearable
                                placeholder="请输入要绑定的手机号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="code" :error="codeError">
                            <el-input
                                type="text"
                                v-model="changeBindPhoneForm.code"
                                autocomplete="off"
                                clearable
                                placeholder="请输入验证码"
                                class="codeIpt"
                            >
                                <span class="yzm" slot="append" :disabled="disabled" @click="getVerificationCode">
                                    {{ yzmtext }}
                                </span>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <p class="agreement" v-if="type==1">
                <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
                <a :href="realNameAgreement" target="_blank">《实名认证服务协议》</a>
            </p>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="handlBindSub('changeBindPhoneForm')">绑定</el-button>
                <el-button round class="next" @click="close">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { identification } from "@http/user_center/userInfo";
import { sendMsg,phoneByAuthentication,changeBindApply,refreshToken} from "@http/userCenter/index";
import NoTrace from '@/utils/noTrace';
let interval = null;
let time = 61;
export default {
    name: 'ChangePhone',
    data () {
        var vAccount = (rule, value, callback) => {
            var phone = this.changeBindPhoneForm.account;
            if (!/^1[23456789]\d{9}$/.test(phone)) {
                callback(new Error("手机号格式不正确"));
            }
            callback();
        };
        var vCode = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入验证码"));
            }
            if (value.trim().length == 0) {
                callback(new Error("验证码不能为空"));
            }
            callback();
        };
        return {
            realNameAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/realNameProtocol',
            noRealName: false,
            bindPhone:false,
            bindFail:false,
            userInfo:{
                name:'',
                idCard:'',
            },
            authenticationStatus:'',
            type:'',
            yzmtext: "获取验证码",
            disabled: false,
            currentTime: 61,
            checked: false,//是否阅读协议
            // 个人用户换绑
            changeBindPhoneForm:{
                account:'',
                type:'',
                code:'',
                clientId:this.$getlocalStorage("queryData")? this.$getlocalStorage("queryData").clientId: "",
            },
            rulesPhone:{
                code: [{ validator: vCode }],
                account: [{ validator: vAccount }],
            },
            accountError:'',
            codeError:'',
        }
    },
    components: {},
    computed: {},
    created() {
        this.init();
    },
    methods: {
        close(){
            this.noRealName=false;
            this.bindPhone=false;
            this.bindFail=false;
            this.$emit('closeProcess')
        },
        init(){
            let that = this;
            identification({hiddenApproval:true}).then((res) => {
                that.authenticationStatus = res.authenticationStatus;//对应的值看AuthenticationName页注释
                that.type = res.type;
                //未实名认证的状态
                if([-1,3,5].includes(res.authenticationStatus)){
                    that.noRealName=true;
                    return
                }
                if(res.type==2){
                    that.userInfo=res.enterprise;
                }else{
                    that.userInfo=res.personal
                }
                that.resetYzm(0);
                that.bindPhone=true;  
            }).catch((err) => {
                console.log(err);
            });
        },
        getVerificationCode() {
            this.accountError=null;
            var phone = this.changeBindPhoneForm.account;
            if (!/^1[23456789]\d{9}$/.test(phone)) {
                this.accountError="请输入正确的手机号"
                return false;
            }
            this.getCode();
            this.disabled = true;
            // 开始获取无痕验证码
            NoTrace.start((nvc) => {
                this.nvc = nvc
            }, this.executeFun, {
                loginName: this.changeBindPhoneForm.account,
                signupType: "PHONE",
                nvc: '',
                afsVersion: 2
            })
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMsg(params);
                    resolve(res)
                    that.$msg("验证码已发送，请注意接收", "success");
                }catch (err) {
                    reject(err)
                    that.resetYzm();
                    that.$msg(err.message);
                }
            })
        },
        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function() {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                    that.resetYzm();
                }
            }, 1000);
        },
        handlBindSub(changeBindPhoneForm){
            let that = this;
            this.$refs[changeBindPhoneForm].validate((valid) => {
                if(!that.checked && that.type==1){
                    that.$msg("请先阅读并勾选协议");
                    return false;
                }
                if (valid) {
                    that.codeError = null;
                    that.accountError = null;
                    let {account,code,clientId}=that.changeBindPhoneForm;
                    if(that.type==1){ //个人
                        phoneByAuthentication({
                            "phone": account,
                            "code": code,
                            "clientId": clientId
                        }).then((res) => {
                            that.resetYzm(0)
                            let redirectUrl = that.$getlocalStorage("queryData") ? that.$getlocalStorage("queryData").redirectUrl: "";
                            if (redirectUrl) {
                                localStorage.removeItem("queryData");
                                window.location.href =decodeURI(redirectUrl)
                            }else{
                                that.$emit('updateUserInfo')
                                that.close();
                            }                           
                        }).catch((err) => {
                            if (err.code == 1) { //验证码错误
                                that.codeError = err.message;
                            }else if (err.code == 2) {//已绑定其它账号
                                that.accountError = err.message;
                            }else if(err.code == 999){ //换绑失败！请使用实名信息与帐号身份相符的手机号：
                                that.$refs["changeBindPhoneForm"].resetFields();
                                that.$refs["changeBindPhoneForm"].clearValidate();
                                that.bindPhone=false;
                                that.bindFail=true;
                            }else{
                                that.$msg(err.message);
                            }
                        });
                    }else{ //企业
                        changeBindApply({
                            account,
                            code,
                            clientId,
                            type:0 //0手机号 1邮箱
                        }).then((res) => {
                            that.close();
                            that.resetYzm(0);
                            that.$router.push('/userCenter/changeBindApply?type=0')
                        }).catch((err) => {
                            if (err.code == 1) { //验证码错误
                                that.codeError = err.message;
                            }else if (err.code == 2) {//已绑定其它账号
                                that.accountError = err.message;
                            }else{
                                that.$msg(err.message);
                            }
                        });
                    }
                }
            })

        },
        resetYzm(btnStatus=1){
            this.disabled = false;
            interval && clearInterval(interval);
            this.yzmtext = btnStatus==0?"获取验证码":'重新获取';
            this.currentTime = time;
        },
        tryAgain(){
            this.bindFail=false;
            this.bindPhone=true;
            this.$nextTick(() => {
                this.$refs["changeBindPhoneForm"].resetFields();
                this.$refs["changeBindPhoneForm"].clearValidate();
            })
        }

    },
}

</script>
<style src="@/assets/css/dialog.less" scoped lang='less'></style>
